import { useMemo, useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import debounce from 'lodash/debounce';

import InputText from '@/design_system/InputText';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const OrderNumber = () => {
  const { t } = useLingui();
  const { request, article, view, errors } = useArticleContext();

  const [orderNumber, setOrderNumber] = useState(article.orderNumber ?? '');

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  const debouncedUpdateArticle = useMemo(() => {
    return debounce(updateArticle, 500);
  }, [updateArticle]);

  return (
    <InputText
      label={
        <>
          <Trans id="article.form.order-number.label">Order number</Trans>
          {!view.warranty.fields.orderNumber.required &&
            !view.warranty.fields.proofOfPurchaseOrOrderNumber.required && <OptionalLabel />}
        </>
      }
      placeholder={t({
        id: 'article.form.order-number.placeholder',
        message: 'Add an order number',
      })}
      size="medium"
      value={orderNumber}
      onChange={(value) => {
        setOrderNumber(value);
        debouncedUpdateArticle({
          data: {
            orderNumber: value.trim() || null,
          },
        });
      }}
      error={
        errors.warranty?.missingOrderNumber
          ? t({
              id: 'article.form.order-number.error.missing',
              message: 'An order number is required',
            })
          : errors.warranty?.missingProofOfPurchaseOrOrderNumber
            ? t({
                id: 'article.form.proof-of-purchase-or-order-number.error.missing',
                message: 'A proof of purchase or an order number is required',
              })
            : undefined
      }
      style={{ flex: 1 }}
    />
  );
};
